import * as React from 'react';
import { Button } from 'react-bootstrap';
import { flow } from 'lodash';
import { change, destroy, reset } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import { mtaActions } from '../../../../../../services/mta/actions';
import { IMtaActions } from '../../../../../../services/mta/models';
import { actions as quoteActions } from '../../../../../../services/quote/reducer';
import { IQuoteActions } from '../../../../../../services/quote/models';

interface IRenewalCancelButtonProps {
  policyId: string;
  controlGroup: string;
  actions: {
    push(path: string);
    reset(formName: string);
    destroy(formName: string);
    mta: IMtaActions;
    quote: IQuoteActions;
  }
  buttonStyle?: any;
}

const RenewalCancelButton = ({ policyId, controlGroup, actions, buttonStyle }: IRenewalCancelButtonProps) => {

  const controlGroupValue = parseInt(controlGroup, 10);

  const handleCancelRenewal = () => {
    Promise.all([
      actions.mta.resetMtaData()
    ]).then(() => {
      actions.push(`/account/make-a-change/selection/${policyId}`);
    });
  }

  return (
    <Button
      bsStyle="primary"
      className="pull-right secondary-button"
      onClick={handleCancelRenewal}
      style={buttonStyle}
    >
      {controlGroupValue <= 4 ? 'MANAGE RENEWAL' : 'THINKING OF LEAVING US?'}
    </Button>
  )
}

export default flow([
  connect(
    () => {
      return {};
    },
    (dispatch) => ({
      dispatch,
      actions: {
        push: bindActionCreators(push, dispatch),
        quote: bindActionCreators({ ...quoteActions }, dispatch),
        mta: bindActionCreators({ ...mtaActions }, dispatch),
        destroy: bindActionCreators(destroy, dispatch),
        reset: bindActionCreators(reset, dispatch),
        change: bindActionCreators(change, dispatch),
      },
    }),
  ),
])(RenewalCancelButton);
